import gql from "graphql-tag";

export const GET_TEAM_INVITATION = gql`
    query TeamInvitation($teamInvitationId: ID!){
        teamInvitation(teamInvitationId: $teamInvitationId) {
            teamInvitationId
            invitationSenderUserId
            teamId
            invitationFirstName
            invitationLastName
            invitationEmailAddress
            invitationExpiresAt
            acceptedAt
            acceptedByUserId
            rejectedAt
            createdAt
            updatedAt
        }
    }
`;

export const GET_TEAM_INVITATIONS = gql`
    query TeamInvitations($teamId: ID!, $showAccepted: Boolean, $searchStr: String, $limit: Int, $offset: Int, $orderList: [String]){
        teamInvitations(teamId: $teamId, showAccepted: $showAccepted, searchStr: $searchStr, limit: $limit, offset: $offset, orderList: $orderList) {
            teamInvitationId
            invitationSenderUserId
            teamId
            invitationFirstName
            invitationLastName
            invitationEmailAddress
            invitationExpiresAt
            acceptedAt
            acceptedByUserId
            rejectedAt
            createdAt
            updatedAt
        }
    }
`;

export const CREATE_TEAM_INVITATION = gql`
    mutation CreateTeamInvitation($newTeamInvitation: newTeamInvitation!) {
        createTeamInvitation(
            newTeamInvitation: $newTeamInvitation
        ) {
            returnCode
            message
            id
            name
        }
    }
`;

export const UPDATE_TEAM_INVITATION = gql`
    mutation UpdateTeamInvitation($changedTeamInvitation: ID!) {
        updateTeamInvitation(
            changedTeamInvitation: $changedTeamInvitation
        ) {
            returnCode
            message
        }
    }
`;

export const DELETE_TEAM_INVITATION = gql`
    mutation DeleteTeamInvitation($deleteTeamInvitationId: ID!) {
        deleteTeamInvitation(
            deleteTeamInvitationId: $deleteTeamInvitationId
        ) {
            returnCode
            message
        }
    }
`;

export const SEND_TEAM_INVITATION = gql`
    mutation SendTeamInvitation($teamInvitationId: ID!) {
        sendTeamInvitation(
            teamInvitationId: $teamInvitationId
        ) {
            returnCode
            message
        }
    }
`;

export const ACCEPT_TEAM_INVITATION = gql`
    mutation AcceptTeamInvitation($teamInvitationId: ID!) {
        acceptTeamInvitation(
            teamInvitationId: $teamInvitationId
        ) {
            returnCode
            message
        }
    }
`;

export const REJECT_TEAM_INVITATION = gql`
    mutation RejectTeamInvitation($teamInvitationId: ID!) {
        rejectTeamInvitation(
            teamInvitationId: $teamInvitationId
        ) {
            returnCode
            message
        }
    }
`;
